import {QuestionModel} from "./QuestionModel";

export class QuestionYesNoModel extends QuestionModel {
  constructor(position: number, question: string, required: boolean, label: string) {
    super(position, question, required, label);
  }
}
